<template>
    <div id="content">
        <popup v-show="hasPopup"
               :popup-type="getPopupType"
               :popup-action="getPopupAction"
               @popup-action="executePopupAction" />
        <form>
            <div class="inner">
                <add-button v-if="$_createActionAllowed" :title="'Přidat marketingové oznámení' | translate" route-name="advertisingBannerNew" />
                <h1 v-translate>Marketingová oznámení</h1>
            </div>
            <div class="inner_white">
                <div class="filter search_only">
                    <div class="field_left">
                        <search-input input-class="search" v-model="formFields.search" />
                    </div>
                  <a @click.stop.prevent="resetFilter" class="btn btn_action btn_grey btn_reset" :title="'Resetovat filtr' | translate" v-translate>Resetovat filtr</a>
                </div>
              <form>
                <div class="scroll-wrapper">
                  <div class="table_overflow" id="contentBox" data-table-id="advertising-banner-list">
                    <table class="vypis" ref="table_with_action_line" v-show="dataLoaded">
                      <thead>
                      <tr v-if="entities.length > 0">
                        <th class="no_padding drag_drop"></th>
                        <th class="no_padding checkbox"></th>
                        <sorting-table-title
                            v-for="title in sortingTableTitles"
                            :key="title.id"
                            :column="title.column"
                            :sort="getActiveSort(title.column)"
                            @changeSorting="changeSorting"
                        >{{ title.name }}
                        </sorting-table-title>
                        <th class="no_padding edit"></th>
                      </tr>
                      </thead>
                      <tbody>
                      <advertising-banner-row
                          v-for="entity in entities"
                          :entity="entity"
                          :key="entity.id"
                          :selectedEntities="selectedEntities"
                          @input="select"
                          @updateEntity="updateEntity"
                          @deleteEntity="deleteEntity"
                      ></advertising-banner-row>
                      <tr v-if="entities.length === 0">
                           <td colspan="10">{{ $gettext('Nebyly nalezeny žádné marketingové oznámení.') }}</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <list-action-line
                    :entities="entities"
                    :selected-entities="filteredSelectedEntities"
                    :multiple-action-options="multipleActionOptions"
                    :offset="formFields.offset"
                    :limit="formFields.limit"
                    :total-count="totalCount"
                    table-id="advertising-banner-list"
                    @select-all="toggleSelectAll"
                    @run-multiple-action="runMultipleAction"
                    @limit="setLimit"
                    @offset="setOffset"
                    ref="action_line"
                ></list-action-line>
              </form>
            </div>
        </form>
    </div>
</template>

<script>
	import AdvertisingBannerRow from "./AdvertisingBannerRow.vue";
	import listActions from "@/components/mixins/list-actions"
  import advertisingBanners from "./mixins/advertisingBanners";

	export default {
		name: "AdvertisingBannerList",
		components: {AdvertisingBannerRow},
		mixins: [listActions, advertisingBanners],
    created(AdvertisingBannerService) {
      this.entityService = AdvertisingBannerService
      this.createdInit()
    },
    data(){
      return {
        moduleName: 'advertisingBanners',
        formFields: {
          sort: {
            column: 'sDateCreated',
            direction: 'desc',
          }
        },
      }
    },
    computed: {
      multipleActionOptions() {
          let options = [
              {value: 'choose', text: this.$gettext('Vyberte akci')},
              {value: 'exportCsv', text: this.$gettext('Exportovat do CSV')},
          ]
        if(this.$_deleteActionAllowed){
          options.push({value: 'delete', text: this.$gettext('Smazat')});
        }

        return options;
      },
      sortingTableTitles() {
          return [
              {id: 1, name: this.$gettext('Název'), column: 'sName'},
              {id: 2, name: this.$gettext('Operátor'), column: 'sOperatorName'},
              {id: 3, name: this.$gettext('Typ akce'), column: 'sActionType'},
              {id: 4, name: this.$gettext('Počet zařízení příjemců'), column: 'sRecipientsCount'},
              {id: 5, name: this.$gettext('Zpracováno'), column: 'sProcessedAt'},
              {id: 6, name: this.$gettext('Zobrazit v'), column: 'sShowAt'},
              {id: 7, name: this.$gettext('Vloženo'), column: 'sDateCreated'},
          ]
      },
      csvHeaders(){
        let headers = this.getCsvHeaderFromSortingTableTitle(this.sortingTableTitles)
        headers.processed_at.callback = (entity) => {return entity.processed_at ? this.$_datetime_format(entity.processed_at) : ''};
        headers.show_at.callback = (entity) => {return entity.show_at ? this.$_datetime_format(entity.show_at) : ''};

        return headers;
      },
    },
		methods: {
			_processListErrorMessage(error) {
				return error['error_message']
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/views/advertisingBanner/AdvertisingBannerList.vue